import { COLORS_CLASSESS } from "@/constants/constants";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const getRandomColor = () => {
  return COLORS_CLASSESS[Math.floor(Math.random() * COLORS_CLASSESS?.length)]
}

